import { render, staticRenderFns } from "./StudentInvitePanel.vue?vue&type=template&id=25673b59&scoped=true"
import script from "./StudentInvitePanel.vue?vue&type=script&lang=js"
export * from "./StudentInvitePanel.vue?vue&type=script&lang=js"
import style0 from "./StudentInvitePanel.vue?vue&type=style&index=0&id=25673b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25673b59",
  null
  
)

export default component.exports